export const DELIVERY_PROVIDER_ROUTE_NAMES = {
  DELIVERIES: 'deliveries',
};
